/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ShoppingCartSimpleOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M8.385 20.835c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43zm10.85 0c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M1.965 3.165h2.55l.54 2.61m0 0 1.91 9.23c.1.46.5.79.98.79h11.93a1 1 0 0 0 .99-.84l1.17-7.36-16.98-1.82z"
})));
// Fill
const ShoppingCartSimpleFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  fillRule: "evenodd",
  d: "M1.965 2.855a.625.625 0 1 0 0 1.25h2.04l2.35 11.33c.16.76.82 1.3 1.59 1.3h11.93c.8 0 1.48-.58 1.6-1.37l1.18-7.36a.588.588 0 0 0-.12-.48.575.575 0 0 0-.43-.24l-16.53-1.77-.45-2.16c-.06-.3-.31-.5-.61-.5h-2.55z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M8.385 21.145c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43zm10.85 0c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43z"
})));
// DuoTone
const ShoppingCartSimpleDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M8.385 20.835c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43zm10.85 0c.79 0 1.43-.64 1.43-1.43 0-.78-.64-1.42-1.43-1.42s-1.43.64-1.43 1.42c0 .79.64 1.43 1.43 1.43z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M19.875 15.795H7.945c-.48 0-.88-.33-.98-.79l-1.91-9.23 16.98 1.82-1.17 7.36a1 1 0 0 1-.99.84z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M1.965 3.165h2.55l.54 2.61m0 0 1.91 9.23c.1.46.5.79.98.79h11.93a1 1 0 0 0 .99-.84l1.17-7.36-16.98-1.82z"
})));
/**
  Icon ShoppingCartSimpleIcon in commerce group
*/
export const ShoppingCartSimpleIcon = createIcon('ShoppingCartSimpleIcon', 'shopping-cart-simple', 'commerce', ShoppingCartSimpleOutline, ShoppingCartSimpleFill, ShoppingCartSimpleDuotone, "0 0 24 24");